module.exports = __webpack_public_path__ + "img/honor3.136770b8.jpg";